import { createSelector } from '@ngrx/store';

import { operatorSettingsFeature } from '../operator-settings.feature';
import { CurrencyLoadState } from '../operator-settings-state.model';

const { selectCurrency } = operatorSettingsFeature;

export const selectCurrencies = createSelector(
  selectCurrency,
  (state) => state.currencies,
);

export const selectCurrencyLoadState = createSelector(
  selectCurrency,
  (state) => state.loadState,
);

export const selectCurrencyError = createSelector(
  selectCurrency,
  (state) => state.error,
);

export const selectIsCurrencyLoading = createSelector(
  selectCurrencyLoadState,
  (loadState: CurrencyLoadState) => loadState === 'loading',
);

export const selectIsCurrencyLoaded = createSelector(
  selectCurrencyLoadState,
  (loadState: CurrencyLoadState) => loadState === 'loaded',
);

export const selectHasCurrencyError = createSelector(
  selectCurrencyLoadState,
  (loadState: CurrencyLoadState) => loadState === 'error',
);
